<template>
    <div class="filter-panel">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                params: {}
            }
        },
        methods: {
            getParams () {
                this.params = {}
                this.$children.forEach((child, index) => {
                    Object.assign(this.params, child.getSelected())
                })
                return this.params
            }
        }
    }
</script>

<style lang="scss">
    @import "~variable";

    .filter-panel {
        .el-button {
            color     : $text-color-secondary;
            font-size : $font-size-base;
        }
        .el-button--danger {
            padding : 4px 9px;
        }
        .el-button--text {
            padding : 5px 9px;
        }
        .active {
            background : #96a1af;
            color      : #fff;
        }
    }
</style>


// WEBPACK FOOTER //
// filterPanel.vue?1e6597eb